const INITIAL_STATE = {
  loading: false,
  list: [],
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ACTION_OFFERS_LOAD':
      return { ...state, loading: action.payload };
    case 'ACTION_OFFERS_FETCHED':
      return { ...state, list: action.payload, loading: false };
    default:
      return state;
  }
};
